interface ExponeanSDK {
	showBanner(
		bannerId: string,
		properties?: Record<string, string | undefined>
	): void;
}

declare global {
	interface Window {
		exponea?: ExponeanSDK;
	}
}

const LEAD_CAPTURE_BANNER_ID = "693ae0d531e0f13c1374296d";

export interface LeadCaptureParams {
	consultantId?: string;
	pwsLink?: string;
	country: string;
	source?: string;
}

/**
 * Open the Bloomreach lead capture banner (newsletter sign-up form).
 * Falls back to default consultant ID "001000" when no consultant is connected.
 */
export function showLeadCaptureBanner(params: LeadCaptureParams): void {
	if (typeof window === "undefined" || !window.exponea) return;

	window.exponea.showBanner(LEAD_CAPTURE_BANNER_ID, {
		consultant_id: params.consultantId ?? "001000",
		pws_link: params.pwsLink,
		country: params.country,
		source: params.source ?? "LeadCapture"
	});
}

/**
 * Selector used to identify Bloomreach weblayer elements in the DOM.
 * Update this if Bloomreach changes its DOM structure.
 */
export const BLOOMREACH_WEBLAYER_SELECTOR =
	".exponea-banner, [id^='exponea-banner'], [class*='exponea-weblayer']";

/**
 * Check if a given DOM element is a Bloomreach weblayer.
 */
export function isBloomreachWebLayer(el: HTMLElement): boolean {
	if (!el.matches) return false;
	return el.matches(BLOOMREACH_WEBLAYER_SELECTOR);
}

/**
 * Remove any active Bloomreach weblayer from the DOM.
 * Used when the wrapping Modal is closed before the user completes the form.
 */
export function removeBloomreachWebLayer(): void {
	if (typeof document === "undefined") return;
	const weblayers = document.querySelectorAll(BLOOMREACH_WEBLAYER_SELECTOR);
	weblayers.forEach((el) => el.remove());
}
